import { demoDialogTitleSx, demoDialogTextSx } from './dialog-styles'

import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'
import { Close } from '@vedmarket/ui-kit'

import { COLORS } from '../../../config/constants'
import { formatDemoCopy } from './page/hero/helpers'
import './introduction-dialog.scss'

const DemoIntroductionDialog = ({ onBegin }: DemoIntroductionDialogProps) => {
  const { t, i18n } = useTranslation()

  return (
    <div className='demo-intro' data-demo-allowed='player'>
      <div className='demo-dialog' role='dialog' aria-modal='true' aria-labelledby='demo-intro-title'>
        <div className='demo-dialog__heading'>
          <Typography
            id='demo-intro-title'
            component='h2'
            sx={demoDialogTitleSx}
          >
            {t('calc__demoPlayer__introTitle')}
          </Typography>
          <ButtonBase
            onClick={onBegin}
            aria-label={t('calc__demoPlayer__close')}
            sx={{
              padding: 0,
              color: COLORS.LIGHT_ACTION,
            }}
          >
            <Close className='demo-intro__close-icon' width={32} height={32} />
          </ButtonBase>
        </div>
        <div className='demo-dialog__copy'>
          <Typography
            className='demo-intro__rocket'
            component='span'
            aria-hidden='true'
            sx={{
              fontSize: 56,
              '@media (min-width: 320px) and (max-width: 767px)': {
                fontSize: 48
              },
              lineHeight: 1,
              flexShrink: 0,
              '@media (min-width: 1200px)': {
                fontSize: 64,
                lineHeight: '64px',
              },
            }}
          >🚀</Typography>
          <div className='demo-dialog__paragraphs' lang={i18n.resolvedLanguage}>
            <Typography
              sx={demoDialogTextSx}
            >
              <Trans
                defaults={formatDemoCopy(t('calc__demoPlayer__introEditable'))}
                components={{
                  bold: <Typography
                    component='strong'
                    sx={{
                      font: 'inherit',
                      letterSpacing: 'inherit',
                      fontWeight: 700
                    }}
                  />,
                  nowrap: <Typography
                    component='span'
                    sx={{
                      font: 'inherit',
                      whiteSpace: 'nowrap',
                      letterSpacing: 'inherit'
                    }}
                  />,
                }}
              />
            </Typography>
            <Typography
              sx={demoDialogTextSx}
            >
              <Trans
                defaults={formatDemoCopy(t('calc__demoPlayer__introFull'))}
                components={{
                  nowrap: <Typography
                    component='span'
                    sx={{
                      font: 'inherit',
                      whiteSpace: 'nowrap',
                      letterSpacing: 'inherit'
                    }}
                  />,
                  hyphen: <Typography
                    component='span'
                    sx={{
                      font: 'inherit',
                      hyphens: 'auto',
                      hyphenateLimitChars: '6 3 8',
                      letterSpacing: 'inherit'
                    }}
                  />,
                }}
              />
            </Typography>
          </div>
        </div>
        <Button variant='contained' fullWidth onClick={onBegin}>
          <Typography
            variant='button'
            sx={{
              lineHeight: '24px',
              letterSpacing: '1px'
            }}
          >{t('calc__demoPlayer__begin')}</Typography>
        </Button>
      </div>
    </div>
  )
}

export default DemoIntroductionDialog
